(() => {
  const initGallery = (gallery) => {
    if (!gallery || gallery.dataset.wewokMobileThumbsReady === 'true') return;

    const mediaList = gallery.querySelector('.product__media-list');
    if (!mediaList) return;

    const mediaItems = Array.from(mediaList.querySelectorAll(':scope > .product__media'));
    if (mediaItems.length < 2) return;

    const images = mediaItems.map((item) => item.querySelector('img')).filter(Boolean);
    if (!images.length) return;

    gallery.dataset.wewokMobileThumbsReady = 'true';

    const thumbs = document.createElement('div');
    thumbs.className = 'wewok-mobile-thumbnails';
    thumbs.setAttribute('aria-label', 'Product image thumbnails');

    const setActive = (index) => {
      mediaItems.forEach((item, itemIndex) => {
        item.classList.toggle('is-wewok-mobile-active', itemIndex === index);
      });

      thumbs.querySelectorAll('.wewok-mobile-thumbnail').forEach((button, buttonIndex) => {
        button.classList.toggle('is-active', buttonIndex === index);
      });
    };

    images.forEach((image, index) => {
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'wewok-mobile-thumbnail';
      button.setAttribute('aria-label', `View product image ${index + 1}`);

      const thumb = document.createElement('img');
      thumb.src = image.currentSrc || image.src;
      thumb.alt = image.alt || '';
      thumb.loading = 'lazy';

      button.appendChild(thumb);
      button.addEventListener('click', () => setActive(index));
      thumbs.appendChild(button);
    });

    mediaList.insertAdjacentElement('afterend', thumbs);
    setActive(0);
  };

  const initAll = () => {
    if (!window.matchMedia('(max-width: 1023px)').matches) return;
    document.querySelectorAll('media-gallery.product__gallery').forEach(initGallery);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll, { once: true });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();